import { AxiosRequestConfig } from 'axios';
import configs from '@/root/configs';
import { request } from '@/services/utils';

export const getNextApiUrl = (endpoint: string): string => {
  if (typeof endpoint !== 'string') {
    throw new Error('endpoint must be string');
  }
  if (endpoint.trim() === '') {
    throw new Error('endpoint must not be empty string');
  }

  // * remove first and last slashes
  const formattedEndpoint = endpoint
    .split('/')
    .filter((x) => x)
    .join('/');

  return `/${configs.nextApiPrefix}/${formattedEndpoint}`;
};

export const getNextAppBaseUrl = (req: TServerSideRequest) => {
  // Get the host from headers
  const host = req.headers.host || '';

  // Check x-forwarded-proto header first (set by proxies/load balancers)
  const forwardedProto = req.headers['x-forwarded-proto'];

  // If x-forwarded-proto exists and includes https, use https
  if (
    forwardedProto &&
    typeof forwardedProto === 'string' &&
    forwardedProto.includes('https')
  ) {
    return `https://${host}`;
  }

  // If we have an x-forwarded-host header, prefer it over the regular host
  const forwardedHost = req.headers['x-forwarded-host'];
  if (forwardedHost && typeof forwardedHost === 'string') {
    // Check if the forwarded host indicates a secure domain
    if (forwardedHost.includes('emofid.com')) {
      return `https://${forwardedHost}`;
    }
    return `http://${forwardedHost}`;
  }

  // Force HTTPS for production domains
  if (host.includes('emofid.com')) {
    return `https://${host}`;
  }

  // Default fallback to http only for development
  return `http://${host}`;
};

export const requestNextApi = <T = any>(
  endpoint: string,
  config: AxiosRequestConfig = {}
): Promise<T> => {
  return request({
    baseURL: window.location.origin,
    url: getNextApiUrl(endpoint),
    withCredentials: true,
    ...config,
  });
};
